import dayjs from "dayjs";

// Age comes straight from the payload when available; otherwise derive it from a
// birth date if one is present.
export function resolveAge(member) {
  if (member?.age != null && member.age !== "") {
    const n = Number(member.age);
    return Number.isFinite(n) ? n : null;
  }
  const dob = member?.birthDate || member?.dateOfBirth || member?.dob;
  if (!dob) return null;
  const parsed = dayjs(dob);
  return parsed.isValid() ? dayjs().diff(parsed, "year") : null;
}

// A "— day off" suffix shown next to a staff member's name anywhere in the
// Activities planner when they're not scheduled to work that day. They stay
// fully selectable (joining a trip / leading on a day off is allowed) — this
// just flags it. `scheduledToday` is supplied by the backend per adult as 0/1
// (or false/true): a falsy-but-present value = day off; a missing/null value
// (students, no schedule concept) = no flag.
export function dayOffSuffix(person) {
  const scheduled = person?.scheduledToday;
  return scheduled != null && !scheduled ? " — day off" : "";
}

// Keep booking-group names short so person lines stay compact.
export function truncateGroup(name) {
  const s = String(name || "").trim();
  return s.length > 8 ? `${s.slice(0, 8)}…` : s;
}

// Build the "Group A — age 14" suffix shown after a person's name to make them
// identifiable when assigning. Students show their booking group (or
// "individual") plus age; adults show their booking group only when they
// actually have one (group leaders do; staff don't, and shouldn't read as
// "individual"). Returns "" until the backend supplies the data.
export function buildMemberDetail(member, isAdult) {
  const parts = [];

  if (member?.bookingGroupName !== undefined) {
    const group = String(member.bookingGroupName || "").trim();
    if (group) {
      parts.push(truncateGroup(group));
    } else if (!isAdult) {
      parts.push("individual");
    }
  }

  const age = resolveAge(member);
  if (age != null) parts.push(`age ${age}`);

  return parts.join(" — ");
}
